<app-form-view [popup]="'true'" [showHelp]="false" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
	<form-title>
		{{locale.translate('new_knowledge_card')}}
	</form-title>
	<content-area>
		<div class="knowledge-card-forms" fxLayout="column" fxLayoutAlign="start stretch">
			<div fxLayout="row" fxLayoutAlign="center center">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="0 1 486px" fxFlex.xs="100" fxLayoutGap="20px"
					fxLayoutGap.xs="10px">
					<ng-container *ngIf="addWorkgroup">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="25px">
							<p class="no-data">{{locale.translate('create_workgroup_text')}}</p>
							<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
							<button mat-stroked-button class="submit-btn" #addWorkgroupBtn
								(click)="workgroupForm('createWorkgroup', {actionElement: addWorkgroupBtn})">
								{{locale.translate('create_a_workgroup')}}</button>
								</div>
						</div>
					</ng-container>
					<ng-container *ngIf="addMembers">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
							<p class="no-data">{{locale.translate('invite_members_text')}}</p>
							<button mat-stroked-button class="submit-btn" #addMemberBtn
								(click)="workgroupForm('inviteUsers', {actionElement: addMemberBtn})">
								{{locale.translate('invite_members')}}</button>
						</div>
					</ng-container>
					<ng-container *ngIf="!addWorkgroup && !addMembers">
						<div fxLayout fxLayoutAlign="center start" class="form-container">
							<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="10px"
								(formObject)="formObjectReader($event)"></app-form-group>
						</div>
						<div fxLayout="column" fxLayoutAlign="start stretch">
							<app-alert id="add-alert"></app-alert>
							<div fxLayout="row" fxLayoutAlign="center center">
								<button [disabled]="submitDisable" mat-stroked-button class="submit-btn" type="button"
									(click)="update()">{{locale.translate('assign')}}</button>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</content-area>
	<insights>
		<app-help></app-help>
	</insights>
</app-form-view>
